import React from "react";
import { createRoot } from "react-dom/client";
import AirframeMroProviderData from "./AirframeMroProviderData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderAirframeMroProviderData: unknown;
	}
}

export function renderAirframeMroProviderData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<AirframeMroProviderData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderAirframeMroProviderData = renderAirframeMroProviderData;
